/**
 * The session state (see `helpers/session.ts`) for function components: they re-render when it changes, also when
 * another tab changes it. Event handlers can call the plain getters instead.
 */
import {useSyncExternalStore} from 'react';

import type {Environment, ShippingStation} from '../helpers/session';
import {getEnvironment, getPolyshoppenUser, getShippingStation, isLoggedIn, subscribe} from '../helpers/session';
import type {User} from '../types/user';

/** The logged in warehouse user, `null` when there is none. */
export const useSessionUser = (): User | null => useSyncExternalStore(subscribe, getPolyshoppenUser);

/**
 * Whether a user is logged in. Re-evaluated whenever the session changes; a session that merely runs out is noticed on
 * the next change or render, as no event marks that moment.
 */
export const useIsLoggedIn = (): boolean => useSyncExternalStore(subscribe, isLoggedIn);

/** The environment (API) the terminal talks to. */
export const useEnvironment = (): Environment => useSyncExternalStore(subscribe, getEnvironment);

/** The picked shipping station and its printer, `null` when none was picked yet. */
export const useShippingStation = (): ShippingStation | null => useSyncExternalStore(subscribe, getShippingStation);
